<template>
  <base-slide-over ref="activate" title="Activate Subscription" size="xl">
    <base-content>
      <div class="tw-mb-2">
        <h2 class="tw-text-lg tw-text-left">Please choose a product</h2>
      </div>
      <base-list-group>
        <base-list-item>
          <base-checkbox :label="platformProduct.productName" :value="platformProduct.productId" v-model="selectedProducts" disabled />
        </base-list-item>
        <base-list-item v-for="(product, index) in filteredProducts" :key="product.productId" :showBottomBorder="!index === filteredProducts.length - 1">
          <base-checkbox :label="product.productName" :value="product.productId" v-model="selectedProducts" />
        </base-list-item>
      </base-list-group>
      <h2 class="tw-text-lg tw-text-left tw-mt-6">Payment Method</h2>
      <base-card class="tw-flex tw-flex-nowrap tw-mt-2" :class="{ 'tw-bg-primary-50': paymentOption === 'card' }">
        <base-radio class="tw-mr-2" value="card" name="paymentOption" v-model="paymentOption"></base-radio>
        <div class="tw-flex tw-flex-col tw-w-full">
          <div class="tw-text-gray-800 tw-text-sm tw-font-normal">Credit/Debit Card</div>
          <base-credit-card-input class="tw-mt-3" ref="creditCardInput" hide-name hide-postal-code />
        </div>
      </base-card>
      <base-card class="tw-flex tw-flex-nowrap tw-mt-2" :class="{ 'tw-bg-primary-50': paymentOption === 'ach' }">
        <base-radio class="tw-mr-2" value="ach" name="paymentOption" v-model="paymentOption"></base-radio>
        <div class="tw-flex tw-flex-col tw-w-full">
          <div class="tw-text-gray-800 tw-text-sm tw-font-normal">Bank Account / ACH</div>
          <bank-account ref="bankAccount" :businessId="businessId" />
        </div>
      </base-card>
    </base-content>
    <template #fixed-bottom>
      <base-content class="tw-text-sm">
        By activating below I agree to the <base-button type="text" @click="agreement">Predictile Subscription Agreement</base-button> and I certify that I am authorized to sign on
        behalf of the Client Business.
      </base-content>
      <div class="tw-p-3 tw-flex tw-justify-end">
        <base-button type="flat" class="tw-w-auto tw-mr-2" @click="hide">
          Cancel
        </base-button>
        <base-button class="tw-w-auto" :loading="isLoading" @click="activate">
          Activate
        </base-button>
      </div>
    </template>
    <agreement ref="agreementModal" />
  </base-slide-over>
</template>
<script>
import BankAccount from "@/components/BankAccount/BankAccount.vue";
import Agreement from "@/views/business/business-subscription/components/Agreement";

export default {
  name: "ActivateSubscription",
  components: {
    BankAccount,
    Agreement,
  },
  props: {
    businessId: String,
  },
  data() {
    return {
      isLoading: false,
      products: [],
      platformProduct: {},
      selectedProducts: [],
      paymentOption: "card",
      token: null,
    };
  },
  computed: {
    filteredProducts() {
      return this.products.filter((product) => {
        return product.productId !== this.platformProduct.productId;
      });
    },
  },
  created() {
    this.loadProducts();
  },
  methods: {
    loadProducts() {
      this.$axios
        .get(`/businesses/${this.businessId}/subscriptions/products`)
        .then((res) => {
          this.products = res.data;
          for (var product of res.data) {
            if (product.productName.toLowerCase().includes("platform")) {
              this.platformProduct = product;
              this.selectedProducts.push(product.productId);
            }
          }
        })
        .catch(() => {});
    },
    show() {
      this.$refs.activate.show();
    },
    hide() {
      this.$refs.activate.hide();
    },
    agreement() {
      this.$refs.agreementModal.show(this.products.filter((p) => this.selectedProducts.includes(p.productId)));
    },
    async activate() {
      this.isLoading = true;
      let products = this.products.filter((p) => this.selectedProducts.includes(p.productId));

      if (this.paymentOption === "card") {
        this.token = await this.$refs.creditCardInput.createToken();
        if (!this.token) {
          this.isLoading = false;
          return;
        }
      }

      if (this.paymentOption === "ach" && this.$refs.bankAccount.last4 == null) {
        this.isLoading = false;
        return;
      }

      this.$axios
        .post(`/businesses/${this.businessId}/subscription`, {
          businessId: this.businessId,
          selectedProducts: products,
          tokenId: this.token ? this.token.id : null,
        })
        .then(() => {
          this.hide();
          this.$emit("save");
          this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Subscription Successful", message: "Your subscription was created successfully" });
        })
        .catch((err) => {
          this.errors = err.response.data;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    href(path) {
      this.$router.push({ path: path });
    },
  },
};
</script>
